/** A workflow platform notification as the bell shows it: one sentence and the page it opens. */
export interface PlatformNotification {
  text: string;
  link: string;
}

/** The platform's notification keys, before the `:<id>` most of them end with (backend reference 9). */
export enum PlatformNotificationKey {
  WORKFLOW_APPROVAL_REQUESTED = 'WORKFLOW_APPROVAL_REQUESTED',
  WORKFLOW_INPUT_REQUESTED = 'WORKFLOW_INPUT_REQUESTED',
  CONNECTION_REAUTH_REQUIRED = 'CONNECTION_REAUTH_REQUIRED',
  WORKFLOW_TRIGGER_UNHEALTHY = 'WORKFLOW_TRIGGER_UNHEALTHY',
  WORKFLOW_RUN_REFUSED_FOR_CREDITS = 'WORKFLOW_RUN_REFUSED_FOR_CREDITS'
}

const SENTENCES: Record<PlatformNotificationKey, (data: Record<string, any>) => PlatformNotification> = {
  [PlatformNotificationKey.WORKFLOW_APPROVAL_REQUESTED]: data => ({
    text: `Approval needed in ${data['workflowName']}: ${data['actionName']}`,
    link: `/approvals/${data['approvalRequestId']}`
  }),
  [PlatformNotificationKey.WORKFLOW_INPUT_REQUESTED]: data => ({
    text: `Question from ${data['workflowName']}: ${data['prompt']}`,
    link: `/tasks/${data['humanInputRequestId']}`
  }),
  [PlatformNotificationKey.CONNECTION_REAUTH_REQUIRED]: data => ({
    text: `${data['connectionName']} needs to be reconnected`,
    link: `/connections/${data['connectionId']}`
  }),
  [PlatformNotificationKey.WORKFLOW_TRIGGER_UNHEALTHY]: data => ({
    text: `The trigger of ${data['workflowName']} stopped receiving events`,
    link: `/workflows/${data['workflowId']}`
  }),
  [PlatformNotificationKey.WORKFLOW_RUN_REFUSED_FOR_CREDITS]: data => ({
    text: `${data['workflowName']} could not start a run: ${data['reason']}`,
    link: '/settings/billing'
  })
};

/**
 * The sentence and link of a workflow platform notification, built from its `data` (the notification carries no link
 * of its own); undefined for any other key, which the bell shows as before.
 */
export function platformNotification(key: string, data: Record<string, any>): PlatformNotification | undefined {
  const sentence = SENTENCES[key.split(':')[0] as PlatformNotificationKey];
  return sentence?.(data);
}
